// extracted by mini-css-extract-plugin
export default {"navigation-buttons":"booking-page_navigation-buttons__I15lP","back-button":"booking-page_back-button__buRay","continue-button":"booking-page_continue-button__dFijc"};